import React from 'react';
import Stylesheet from './Reports.module.css';
import Button from '../../../../../elements/Button/Button';
import { AppContext } from '../../../../../contexts/app';
import { ico_bolt, ico_search, ico_chart_line } from '../../../../../icon';
import Input from '../../../../../elements/Input/Input';
import { useHistory, useLocation } from 'react-router-dom';
import { TableContext } from '../../../context/table';
import { QueryContext } from '../../../context/query';
import Datepicker from '../../../../../elements/Datepicker/Datepicker';
import View from './View/View';
import util from '@enigma/core/utilities';

const Reports = (props) => {
    const location = useLocation();
    const history = useHistory()
    let app = null;
    let table = null;
    let query = null;
    const init = (appContext, tableContext, queryContext) => {
        app = appContext;
        table = tableContext;
        query = queryContext;
    }
    const setSearch = value => {
        if (value === "") {
            clearSearch();
            return;
        }
        if (query?.search.length === 0)
            history.push(`${location.search 
            ? `${location.search}&` : "?"}search=${value}`)
        else {
            let url = "";
            // clear search
            const searches = location.search.split('&');
            for (const query of searches) 
                if (!(query.search('search=') > -1)) 
                    url += query;
            history.push(`${url && url !== "?" 
            ? `${url}&` : "?"}search=${value}`)
        }
    }
    const clearSearch = _ => {
        let url = "";
        // clear search
        const searches = location.search.split('&');
        for (const query of searches) 
            if (!(query.search('search=') > -1)) 
                url += query;
        history.push(`${url === "" ? "?" : url}`)
    }
    const setMinRange = date => { query.setMinDate(date) }
    const getMinRange = _ => {
        // get current date
        const currentDate = new util.cdate(table.filter.min_date);
        return currentDate.format("yyyy-mm-dd");
    }
    const setMaxRange = date => {
        query.setMaxDate(date);
    }
    const content = config => {
        if (config.disableFilter) 
            return null;
        else {
            return (
                <div className={config.basic ? Stylesheet.Basic : Stylesheet.ButtonGroup}>
                    <div className={Stylesheet.Group}>
                        <h5 className={Stylesheet.Title}>record set</h5>
                        <Input placeholder='search records' 
                        icon={config.basic ? ico_search : undefined}
                        onChange={value => setSearch(value)} 
                        disabled={query?.selected.records?.length > 0 
                        || table?.records?.length === 0}/>
                        <Button disabled={query?.selected.records?.length > 0 
                        || table?.records?.length === 0 || query?.search?.length === 0} 
                        onClick={clearSearch} secondary>
                        {ico_search}&emsp;clear</Button>
                    </div>
                    <div className={Stylesheet.Group}>
                        <h5 className={Stylesheet.Title}>record range</h5>
                        <div className={Stylesheet.Field}>
                            <h5 className={Stylesheet.Title}>from</h5>&emsp;
                            <Datepicker defaultValue={getMinRange()}
                            max={Date.now()}
                            onChange={value => setMinRange(value)} 
                            disabled={query?.selected.records?.length > 0} 
                            />
                        </div>
                        <div className={Stylesheet.Field}>
                            <h5 className={Stylesheet.Title}>to</h5>&emsp;&emsp;
                            <Datepicker max={Date.now()}
                            onChange={value => setMaxRange(value)} 
                            disabled={query?.selected.records?.length > 0} 
                            />
                        </div>
                    </div>
                    <div className={Stylesheet.Group}>
                        <h5 className={Stylesheet.Title}>reports</h5>
                        <Button 
                        disabled={table?.schema === undefined 
                        || query?.selected.records.length > 0 
                        || query?.selected.columns.length > 0
                        || config?.lock}
                        secondary onClick={ _ => app.toggleModal(ico_bolt, 
                            <View app={app} table={table} query={query} />, 
                            `${table.metadata.name} reports`)}>
                        {ico_bolt}&emsp;data reports</Button>
                        <Button 
                        primary={table.config.visualizationMode}
                        secondary={!table.config.visualizationMode}
                        disabled={table?.records?.length === 0
                        || !query.report.report?.isGroup}
                        onClick={ _ => query.setConfig({...table.config, 
                        visualizationMode: !table.config.visualizationMode})}>
                        {ico_chart_line}&emsp;data visuals</Button>
                    </div>
                </div>
            )
        }
    }

    return (
        <AppContext.Consumer>
            {app => (
                <TableContext.Consumer>
                {table => (
                    <QueryContext.Consumer>
                        {query => (
                            <div className={Stylesheet.Container}>
                                {init(app, table, query)}
                                {content(table.config)}
                            </div>
                        )}
                    </QueryContext.Consumer>
                )}
            </TableContext.Consumer>
            )}
        </AppContext.Consumer>
    )
}

export default Reports;